// app/loading.tsx  — this runs on every page load & client nav
"use client";

import React from "react";

export default function Loading() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
      <iframe
        src="https://lottie.host/embed/41809628-db87-41af-8494-d3c93f4dd79d/lHQnpF7ysz.lottie"
        style={{ width: 300, height: 300, border: "none" }}
        allowFullScreen
      />
    </div>
  );
}
